import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import jarHara from "../assets/jar-hara.webp";
import jarTurmeric from "../assets/jar-turmeric.webp";
import jarHoney from "../assets/jar-honey.webp";
import { useAuth } from "../context/AuthContext";
import "./Cart.css";

var CART_IMAGES = {
  "hara-namak": jarHara,
  turmeric: jarTurmeric,
  honey: jarHoney,
  "hemp-salt": jarHara,
  "flax-salt": jarHara,
};

export default function Cart() {
  const { cart, removeFromCart, updateQuantity, total, subtotal, bundleDiscount, bundleActive, eligibleQty, BUNDLE_MIN_QTY, clearCart } = useCart();
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  function handleCheckout() {
    if (!currentUser) { navigate("/login"); return; }
    navigate("/checkout");
  }

  if (cart.length === 0) {
    return (
      <div className="cart-page">
        <div className="page-container">
          <div className="cart-empty">
            <span>🛒</span>
            <h2>Your cart is empty</h2>
            <p>Add some pure mountain goodness!</p>
            <Link to="/products" className="btn-primary">Browse Products</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="page-container">
        <span className="section-label">Shopping Cart</span>
        <h1 className="cart-title">Your Cart</h1>
        <div className="cart-layout">
          <div className="cart-items">
            {cart.map(item => (
              <div key={item.id} className="cart-item card">
                <img src={CART_IMAGES[item.id] || jarHara} alt={item.name} className="cart-item-icon" />
                <div className="cart-item-info">
                  <h3>{item.name}</h3>
                  <p className="cart-item-price">₹{item.price} each</p>
                </div>
                <div className="cart-item-controls">
                  <div className="quantity-control">
                    <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                  </div>
                  <p className="cart-item-subtotal">₹{item.price * item.quantity}</p>
                  <button className="remove-btn" onClick={() => removeFromCart(item.id)}>✕</button>
                </div>
              </div>
            ))}
            <button className="clear-cart" onClick={clearCart}>Clear Cart</button>
          </div>
          <div className="cart-summary card">
            <h2>Order Summary</h2>
            <div className="summary-rows">
              {cart.map(item => (
                <div key={item.id} className="summary-row">
                  <span>{item.name} × {item.quantity}</span>
                  <strong>₹{item.price * item.quantity}</strong>
                </div>
              ))}
            </div>
            <div className="summary-divider"></div>
            {bundleActive ? (
              <>
                <div className="summary-row">
                  <span>Subtotal</span>
                  <strong>₹{subtotal}</strong>
                </div>
                <div className="summary-row summary-discount">
                  <span>Buy 2+ Salts Discount (10%)</span>
                  <strong>-₹{bundleDiscount}</strong>
                </div>
                <div className="summary-divider"></div>
                <div className="summary-total">
                  <span>Total</span>
                  <strong>₹{total}</strong>
                </div>
              </>
            ) : (
              <div className="summary-total">
                <span>Total</span>
                <strong>₹{total}</strong>
              </div>
            )}
            {!bundleActive && eligibleQty > 0 && eligibleQty < BUNDLE_MIN_QTY && (
              <p className="bundle-hint">Add {BUNDLE_MIN_QTY - eligibleQty} more eligible item to unlock 10% off!</p>
            )}
            <button className="btn-ochre" style={{ width: "100%", marginTop: 20 }} onClick={handleCheckout}>
              Proceed to Checkout →
            </button>
            {!currentUser && <p className="cart-login-note">You'll need to sign in to checkout</p>}
            <Link to="/products" className="continue-shopping">← Continue Shopping</Link>
          </div>
        </div>
      </div>
    </div>
  );
}